/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ClothesHangerIcon16Light } from './ClothesHangerIcon16Light';
import { ClothesHangerIcon16Regular } from './ClothesHangerIcon16Regular';
import { ClothesHangerIcon16Solid } from './ClothesHangerIcon16Solid';
import { ClothesHangerIcon20Light } from './ClothesHangerIcon20Light';
import { ClothesHangerIcon20Regular } from './ClothesHangerIcon20Regular';
import { ClothesHangerIcon20Solid } from './ClothesHangerIcon20Solid';
import { ClothesHangerIcon24Regular } from './ClothesHangerIcon24Regular';
import { ClothesHangerIcon24Solid } from './ClothesHangerIcon24Solid';
import { ClothesHangerIcon32Regular } from './ClothesHangerIcon32Regular';
import { ClothesHangerIcon64Regular } from './ClothesHangerIcon64Regular';
var sizes = {
    16: {
        light: ClothesHangerIcon16Light,
        regular: ClothesHangerIcon16Regular,
        solid: ClothesHangerIcon16Solid,
    },
    20: {
        light: ClothesHangerIcon20Light,
        regular: ClothesHangerIcon20Regular,
        solid: ClothesHangerIcon20Solid,
    },
    24: {
        regular: ClothesHangerIcon24Regular,
        solid: ClothesHangerIcon24Solid,
    },
    32: {
        regular: ClothesHangerIcon32Regular,
    },
    64: {
        regular: ClothesHangerIcon64Regular,
    },
};
export var ClothesHangerIcon = forwardRef('ClothesHangerIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
